import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { toLocaleDateTimeString } from "@utils";

interface DeleteCareplanModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  deleteOrder: () => void;
  lastSubmittedAt: string | null;
}

const DeleteCareplanModal = ({
  open,
  setOpen,
  deleteOrder,
  lastSubmittedAt,
}: DeleteCareplanModalProps) => {
  const confirm = async () => {
    deleteOrder();
    setOpen(false);
  };

  const contentText = lastSubmittedAt
    ? `Are you sure you want to discard your changes and revert to the last submitted version at:`
    : "Are you sure you want to discard this careplan?";

  return (
    <Dialog open={open} maxWidth="xs">
      <DialogTitle>
        {lastSubmittedAt ? "Discard changes?" : "Discard careplan?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {contentText}
          <br />{" "}
          {/* Some jank to stop the time from wrapping around the hyphen */}
          {lastSubmittedAt
            ? `${toLocaleDateTimeString(lastSubmittedAt, "datetime")}?`
            : null}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="primary"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button variant="text" color="error" onClick={confirm}>
          Discard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCareplanModal;
